import { Link } from 'react-router-dom';

import image1 from '../../../../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_detailed_img_1.png';
import image2 from '../../../../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_detailed_img_2.png';
import image3 from '../../../../assets/images/work/nevada-gold-lock-tag/NevadaGoldLockTag_detailed_abovefooter.png';
import artwork from '../../../../assets/images/art_2.png';

const Data_NevadaGoldLockTag = {
    content: (
        <>
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">PROBLEM</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            Lock and Tag procedures protect workers from unexpected energization and
                                            hazardous stored energy. Understanding the theory is essential, but workers
                                            also need opportunities to perform the complete energy isolation process
                                            before applying those skills around real people and equipment.
                                        </p>
                                        <br />
                                        <p>
                                            Nevada Gold Corporation wanted to strengthen its training with a safe,
                                            practical environment where learners could build procedural knowledge,
                                            hazard awareness, and confidence without exposure to real hazardous energy.
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-6 second-column">
                                    <h4 className="heading heading-small light-2">CHALLENGES</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            The experience needed to guide learners through every stage of Lock and Tag
                                            while preserving the decisions, sequence, and equipment interactions that
                                            make the procedure effective in the field.
                                        </p>
                                        <br />
                                        <p>
                                            It also needed to deliver a consistent foundation across operating
                                            locations. Bringing equipment and environmental features from multiple sites
                                            into one shared digital environment would allow workers to encounter
                                            situations beyond those found at their own location while reinforcing a
                                            common organizational approach.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="project-content">
                <div className="project-content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="project-content-inner">
                                    <h2 className="heading heading-large dark-1">
                                        Practice the complete energy isolation process before working around real
                                        hazardous energy.
                                    </h2>

                                    <div className="paragraph dark-1">
                                        <p>
                                            The Nevada Gold Lock and Tag Program moves training beyond theory by
                                            allowing workers to actively perform the procedure in a simulated
                                            environment. Learners interact with realistic equipment, locate isolation
                                            points, make decisions, and follow the required sequence from initial hazard
                                            recognition through the safe return of equipment to service.
                                        </p>
                                        <br />
                                        <p>
                                            Performing each action in context helps learners understand not only what to
                                            do, but why every step is critical to protecting themselves and the people
                                            working around them.
                                        </p>
                                    </div>

                                    <div className="heading heading-medium dark-1">
                                        <p>From Hazard Recognition to Return to Service</p>
                                    </div>

                                    <div className="paragraph dark-1">
                                        <p>
                                            The experience takes learners through the complete Lock and Tag procedure in
                                            a clear, practical sequence:
                                        </p>
                                    </div>

                                    <div className="text-list medium dark-1">
                                        <ul>
                                            <li>Recognize hazardous energy sources and understand the equipment</li>
                                            <li>Prepare equipment for shutdown</li>
                                            <li>Identify and isolate each energy source</li>
                                            <li>Apply the appropriate locks and tags</li>
                                            <li>Control stored and residual energy</li>
                                            <li>Verify that the equipment is in a zero-energy state</li>
                                            <li>Follow the correct process for returning equipment to service</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-image-wrapper">
                        <div className="single-image">
                            <img
                                src={image1}
                                alt="Learner interacting with equipment in the Nevada Gold Lock and Tag Program"
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                        <div className="single-image">
                            <img
                                src={image2}
                                alt="Energy isolation procedure in the Nevada Gold simulated training environment"
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="project-content-inner">
                                    <h2 className="heading heading-medium dark-1">
                                        One Shared Environment, Consistent Training
                                    </h2>

                                    <div className="paragraph dark-1">
                                        <p>
                                            Equipment and environmental features from multiple operating locations are
                                            brought together in a shared digital training environment. This gives
                                            workers the same fundamental experience regardless of where they are located
                                            and introduces them to equipment or situations they may not regularly
                                            encounter at their own site.
                                        </p>
                                        <br />
                                        <p>
                                            To strengthen that sense of familiarity, we custom-built a character based
                                            on Nevada Gold Corporation's operational uniform code and safety standards.
                                            The character's clothing, PPE, and visual safety details help ground
                                            learners in an environment that feels connected to their own operations.
                                        </p>
                                        <br />
                                        <p>
                                            The shared experience reinforces a consistent approach to hazardous energy
                                            control while helping learners understand their individual responsibilities
                                            within the larger Lock and Tag process.
                                        </p>
                                    </div>

                                    <div className="heading heading-medium dark-1">
                                        <p>Building Awareness, Responsibility, and Confidence</p>
                                    </div>

                                    <div className="paragraph dark-1">
                                        <p>
                                            The program is designed to build more than procedural recall. Learners
                                            develop hazard awareness, explore the consequences of unexpected
                                            energization and stored energy, and practise making the decisions required
                                            to perform the process correctly.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-image">
                        <img
                            src={image3}
                            alt="Lock and Tag equipment represented in the Nevada Gold training program"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                </div>
            </div>

            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">RESULTS</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            The program creates a bridge between classroom learning and hands-on field
                                            training. Workers can practise the fundamentals of hazardous energy control,
                                            repeat the required sequence, and build confidence before applying their
                                            knowledge in an operating environment.
                                        </p>
                                        <br />
                                        <p>
                                            By providing a consistent experience without exposure to real hazardous
                                            energy, the training helps prepare learners to perform Lock and Tag
                                            procedures safely around real people, equipment, and operating conditions.
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-5 offset-lg-1 second-column">
                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">PLATFORM</h4>
                                        <div className="paragraph light-1">
                                            <p>PCVR, NXR</p>
                                        </div>
                                    </div>

                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">CLIENT</h4>
                                        <div className="paragraph light-1">
                                            <p>Nevada Gold Corporation</p>
                                        </div>
                                    </div>

                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">ONLINE</h4>
                                        <div className="paragraph light-1">
                                            <p>
                                                <a
                                                    href="https://www.barrick.com/English/operations/nevada-gold-mines/default.aspx"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Nevada Gold Mines
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-content-footer">
                        <div className="container">
                            <div className="row align-items-lg-center">
                                <div className="col-md-6">
                                    <h3 className="heading heading-large light-1">
                                        Have an idea?
                                        <br />
                                        Let's explore it together.
                                    </h3>
                                </div>
                                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                                    <div className="button-wrapper">
                                        <Link className="button button-1" to="/Contact">
                                            Contact Us
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="artwork artwork-2" aria-hidden="true">
                        <img src={artwork} alt="" loading="lazy" decoding="async" />
                    </div>
                </div>
            </div>
        </>
    ),
};

export default Data_NevadaGoldLockTag;
